function LoyaltyDetailMetaDivider() {
  return <span className="loyalty-detail-meta-divider">|</span>;
}

function LoyaltyDetailMetaRow({ children, className = "" }) {
  return <div className={["loyalty-detail-meta", className].filter(Boolean).join(" ")}>{children}</div>;
}

export { LoyaltyDetailMetaDivider };
export default LoyaltyDetailMetaRow;
